// Original at https://github.com/nextauthjs/next-auth/blob/main/packages/core/src/lib/pages/signin.tsx

import SignInPage from '../components/SignInPage/SignInPage';
import getSignInPageViewModels from '../helpers/getSignInPageViewModels';

export const SignInPagePath = '/sign-in';

export default SignInPage;

export async function getStaticProps() {
  const viewModels = await getSignInPageViewModels();

  return {
    props: { page: viewModels.signInPage },
  };
}
